export default "__VITE_ASSET__DC72C0Ok__"